module.exports = __webpack_public_path__ + "img/gyah.508b255e.png";